export const HISTOGRAM_MISSING = '#EBEBEB';
export const HISTOGRAM_BAR = '#004D67';
export const HISTOGRAM_SELECTED_AREA = '#429198';

export const EMPTY_DATA_TEXT = '#A6A6A6';
